import gql from "graphql-tag";

export const updateSurveyMutation = gql`
  mutation updateSurvey(
    $id: ID!
    $title: String
    $text: String
    $buttonText: String
    $url: String
    $startsAt: Timestamp
    $endsAt: Timestamp
    $maxShows: Int
  ) {
    updateSurvey(
      id: $id
      title: $title
      text: $text
      buttonText: $buttonText
      url: $url
      startsAt: $startsAt
      endsAt: $endsAt
      maxShows: $maxShows
    ) {
      id
    }
  }
`;

export const deleteSurveyMutation = gql`
  mutation deleteSurvey($userId: ID!) {
    deleteSurvey(id: $userId) {
      id
    }
  }
`;
